import { render, staticRenderFns } from "./DoctorAvatarEditor.vue?vue&type=template&id=04d347bb&"
import script from "./DoctorAvatarEditor.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorAvatarEditor.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d347bb')) {
      api.createRecord('04d347bb', component.options)
    } else {
      api.reload('04d347bb', component.options)
    }
    module.hot.accept("./DoctorAvatarEditor.vue?vue&type=template&id=04d347bb&", function () {
      api.rerender('04d347bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DoctorAvatarEditor/DoctorAvatarEditor.vue"
export default component.exports